module.exports = global.config = {
    baseUrl : "https://metaage.app"
}